<template>
  <div>
    <h3 class="diet-title">{{ title }}</h3>
    <el-checkbox-group v-loading="loading" :value="checkedValues" :min="1" @input="updateDiet">
      <ul>
        <li v-for="diet in dietList" :key="diet.id" class="diet-element">
          <el-checkbox :label="diet.id" :disabled="disabled" :accesskey="diet.accessKey">
            <p class="diet-title">
              {{ diet.label }}
              <svg-icon :icon="diet.icon" class="svg-diet-icon" />
            </p>
            <p v-if="displayDescription" class="diet-description">
              {{ diet.description }}
            </p>
          </el-checkbox>
        </li>
      </ul>
    </el-checkbox-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SvgIcon from '@/components/SvgIcon';
import { NAVIGATION_ACCESS_KEYS } from '@/constants';

const { dietaryOptionsFilter: accessKeys } = NAVIGATION_ACCESS_KEYS;

export default {
  name: 'DietSelection',
  components: {
    SvgIcon,
  },
  props: {
    displayDescription: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    checkedValues: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('diets', { diets: (state) => state.diets }),
    loading() {
      return !this.diets.length;
    },
    dietList() {
      if (this.diets.length) {
        const filteredDiets = this.diets.filter((d) => d.name !== 'Extras');
        return filteredDiets.map((diet) => ({
          ...diet,
          icon: diet.name.toLowerCase(),
          label: this.$t(`settings.checkboxes.${diet.name.toLowerCase()}Label`),
          description: this.$t(`settings.checkboxes.${diet.name.toLowerCase()}Description`),
          accessKey: accessKeys[diet.name.toLowerCase()],
        }));
      }
      return [];
    },
  },
  methods: {
    updateDiet(updatedValue) {
      this.$emit('checked', updatedValue);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';

h3.diet-title {
  font-weight: bold;
  font-size: $card-title;
  margin-bottom: 20px;
  text-align: center;
}

.diet-element:not(:last-child) {
  margin-bottom: 14px;
}
.diet-description {
  font-size: $label-description-text-size;
  color: $label-description-text-color;
}

/deep/ .el-checkbox {
  &__label {
    display: inline-grid;
  }
  &__input {
    &.is-checked + {
      .el-checkbox {
        &__label {
          color: $label-text-color;
        }
      }
    }
    &.is-checked {
      .el-checkbox {
        &__inner {
          background-color: $checkbox-background-color;
          border-color: $checkbox-background-color;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/catering/DietSelection.vue